__turbopack_context__.v({
  "donation-widget": "jp7hZa_donation-widget",
  "donation-widget__account-info": "jp7hZa_donation-widget__account-info",
  "donation-widget__back-button": "jp7hZa_donation-widget__back-button",
  "donation-widget__bottom_shade": "jp7hZa_donation-widget__bottom_shade",
  "donation-widget__button": "jp7hZa_donation-widget__button",
  "donation-widget__checkbox-group": "jp7hZa_donation-widget__checkbox-group",
  "donation-widget__checkbox-group__popup": "jp7hZa_donation-widget__checkbox-group__popup",
  "donation-widget__checkbox-group__popup-trigger": "jp7hZa_donation-widget__checkbox-group__popup-trigger",
  "donation-widget__first-charge": "jp7hZa_donation-widget__first-charge",
  "donation-widget__form": "jp7hZa_donation-widget__form",
  "donation-widget__frequency-options": "jp7hZa_donation-widget__frequency-options",
  "donation-widget__input-group": "jp7hZa_donation-widget__input-group",
  "donation-widget__input-group__suffix": "jp7hZa_donation-widget__input-group__suffix",
  "donation-widget__input-group__suggested-sums": "jp7hZa_donation-widget__input-group__suggested-sums",
  "donation-widget__input-group__suggested-sums__button": "jp7hZa_donation-widget__input-group__suggested-sums__button",
  "donation-widget__input-group__suggested-sums__button--active": "jp7hZa_donation-widget__input-group__suggested-sums__button--active",
  "donation-widget__message-sub": "jp7hZa_donation-widget__message-sub",
  "donation-widget__pane": "jp7hZa_donation-widget__pane",
  "donation-widget__pane--active": "jp7hZa_donation-widget__pane--active",
  "donation-widget__pane--entering-backward": "jp7hZa_donation-widget__pane--entering-backward",
  "donation-widget__pane--entering-forward": "jp7hZa_donation-widget__pane--entering-forward",
  "donation-widget__pane--exiting-backward": "jp7hZa_donation-widget__pane--exiting-backward",
  "donation-widget__pane--exiting-forward": "jp7hZa_donation-widget__pane--exiting-forward",
  "donation-widget__panes": "jp7hZa_donation-widget__panes",
  "donation-widget__payment-option": "jp7hZa_donation-widget__payment-option",
  "donation-widget__payment-options": "jp7hZa_donation-widget__payment-options",
  "donation-widget__privacy-checkbox-group": "jp7hZa_donation-widget__privacy-checkbox-group",
  "donation-widget__privacy-link": "jp7hZa_donation-widget__privacy-link",
  "donation-widget__spinner": "jp7hZa_donation-widget__spinner",
});
